import { call, getContext, put, select, cancel } from 'redux-saga/effects';
import { loadPublishTermsStart, loadPublishTermsSuccess, loadPublishTermsFail } from '../../../reducers';
import { getPublishTerms as getPublishTermsService, TGetPublishTermsResult } from '../../../../services/publishTerms';
import { IConfig } from '@cian/config/shared';
import { ILogger } from '@cian/logger';
import { IHttpApi } from '@cian/http-api/shared';
import { getParameters, isParametersValid } from './utils';
import { IAppState } from '../../../types';
import { getIsNewPublishTermsEnabled } from '../../../../utils/publishTerms';
import { ITelemetryService } from '../../../../types/telemetryService';
import { selectIsAddJKState } from '../../../../selectors/jk';

export function* getPublishTerms() {
  try {
    const config: IConfig = yield getContext('config');
    const logger: ILogger = yield getContext('logger');
    const httpApi: IHttpApi = yield getContext('httpApi');
    const telemetryService: ITelemetryService = yield getContext('telemetryService');

    const state: IAppState = yield select();

    const { abExperiments } = state;
    const { search } = window.location;

    const isAddJKState = selectIsAddJKState(state);

    if (!getIsNewPublishTermsEnabled({ search, config, abExperiments, isAddJKState })) {
      yield cancel();
    }

    yield put(loadPublishTermsStart());

    const subdomain = config.getStrict<string>('subdomain');
    const parameters = getParameters({ state, config });

    if (!isParametersValid(parameters)) {
      yield put(loadPublishTermsFail());
      yield cancel();
    }

    const response: TGetPublishTermsResult = yield call(getPublishTermsService, {
      httpApi,
      logger,
      telemetryService,
      parameters,
      subdomain,
    });

    if (response.success) {
      yield put(loadPublishTermsSuccess(response.payload));
    } else {
      yield put(loadPublishTermsFail(response.payload));
    }
  } catch (e) {
    yield put(loadPublishTermsFail());

    throw new Error(e.toString());
  }
}
